import client from '../../client';
import type {
  ICheckFileNameParams,
  IDeleteManualParams,
  IFileAppliedParams,
  IGetManualHistoryParams,
  IGetManualsParams,
  ILinkedModelsParams,
  IManualFileUploadUrlParams,
  IPutLinkedModelsParams,
} from './types';

export const aiAgentManualApis = {
  getManuals: ({ companyId, ...rest }: IGetManualsParams) =>
    client.get(`/ai-agent/companies/${companyId}/manuals`, {
      params: rest,
    }),
  getManualHistory: ({ companyId, fileUploadId, ...rest }: IGetManualHistoryParams) =>
    client.get(`/ai-agent/companies/${companyId}/manuals/${fileUploadId}/history`, { params: rest }),
  getAiAgentLearningUsage: (data: { companyId: number }) => client.get(`/ai-agent/companies/${data.companyId}/manuals/usage`),
  deleteManual: (data: IDeleteManualParams) =>
    client.delete(`/ai-agent/companies/${data.companyId}/manuals/${data.fileUploadId}`),
  putFileApplied: (data: IFileAppliedParams) => client.put(`/ai-agent/model/file-upload/file-use`, data),
  getManualPresignedUrl: ({ companyId, data }: IManualFileUploadUrlParams) =>
    client.put(`/ai-agent/companies/${companyId}/manuals/upload`, data),
  checkFileName: ({ companyId, ...rest }: ICheckFileNameParams) =>
    client.get(`/ai-agent/companies/${companyId}/manuals/check-file-name`, { params: rest }),
  getLinkedModels: ({ companyId, fileUploadId }: ILinkedModelsParams) =>
    client.get(`/ai-agent/companies/${companyId}/manuals/${fileUploadId}/models`),
  putLinkedModels: ({ companyId, fileUploadId, ...rest }: IPutLinkedModelsParams) =>
    client.put(`/ai-agent/companies/${companyId}/manuals/${fileUploadId}/models`, rest),
};
